import { render } from "./SelectAreaField.vue?vue&type=template&id=1602a4e2&scoped=true"
import script from "./SelectAreaField.vue?vue&type=script&lang=js"
export * from "./SelectAreaField.vue?vue&type=script&lang=js"

import "./SelectAreaField.vue?vue&type=style&index=0&id=1602a4e2&scoped=true&lang=scss"

import exportComponent from "/Users/shuaqq/Desktop/jysports/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1602a4e2"]])

export default __exports__